'use client'

import { motion } from 'framer-motion'
import { useSearchParams } from '@/lib/hooks'
import { cn } from '@/lib/utils'

interface CartCheckoutLayoutProps
  extends React.ComponentPropsWithoutRef<'div'> {}

export const CartCheckoutLayout = ({ children }: CartCheckoutLayoutProps) => {
  const { isCheckout, showMobileCart } = useSearchParams()

  return (
    <motion.div
      className={cn(
        'lg:h-[calc(var(--inner-layout-height)] ml-auto hidden w-full flex-col rounded-lg border border-gray-100 bg-white px-4 pb-6 pt-5 shadow-block will-change-auto md:px-6 lg:flex dark:border-gray-700',
        {
          'w-[calc(100svw-var(--body-x-padding)-var(--body-x-padding))] max-w-full shrink-0':
            isCheckout,
          'flex w-full': showMobileCart,
        },
      )}
    >
      {children}
    </motion.div>
  )
}
